import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import EditFormSection from './EditFormSection.vue';
import TabComponent from '@/components/TabComponent.vue';

import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const route = useRoute();

const branchId = route.params.id as unknown as string;
const blockedDateId = route.params.blockedDateId as unknown as string;

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        href: `/branches/${branchId}/blocked-dates/edit/${blockedDateId}`,
        count: 0,
        allowed: true
    },
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Edit Booking",
    "show-back": "",
    backUrl: `/branches/${_unref(branchId)}/blocked-dates`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(EditFormSection, {
          "branch-id": _unref(branchId),
          "blocked-date-id": _unref(blockedDateId)
        }, null, 8, ["branch-id", "blocked-date-id"])
      ])
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})